import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../constants'
import { Country } from '../../../model/country'
import { ItemListComponent } from '../item-list/item-list.component'
import { ViewEncapsulation } from '@angular/core';
import { FormGroup, UntypedFormControl, FormsModule, Validators } from '@angular/forms'
import { StringValidator } from '../base-item/string.validator'

declare var require: any

@Component({
  selector: 'app-country-list',
  templateUrl: '../item-list/item-list.component.html',
  styleUrls: ['../../../styles/global.scss','../item-list/item-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CountryListComponent extends ItemListComponent {


// OVERRIDDEN METHODS:

  setTitle() {
    this.pageTitle += "Country list"
  }

  getLinkToEdit(item) {
    // console.log("Item = ", item)
    return "/data/constants/countries/"+this.getItemId(item)
  }

  getItemsName() {
    return "Countries"
  }

  getItemName() {
    return "Country"
  }

  getItemId(item) {
    return item.countryCode
  }

  addItemTHValues(tableid) {
    let str = ""
    let tab = document.getElementById(tableid)
    if (!tab)
      return
    let elem = this.addElement(tab, "thead", '')
    if (!elem)
      return
    while (elem.firstChild) {
      elem.removeChild(elem.lastChild)
    }
    this.addElement(elem, 'th', 'Code')
    this.addElement(elem, 'th', 'Name')
    this.addElement(elem, 'th', 'Offset')
    this.addElement(elem, 'th', 'Tag')
    this.addElement(elem, 'th', 'Timezone')
    this.addElement(elem, 'th', '')
  }


  addItemTDValues(item) {
    let elem = document.getElementById(this.getTableId())
    if (!elem)
      return
    let tr = this.addElement(elem, "tr", '')
    if (!tr)
      return
    this.addElement(tr, 'td', this.getItemId(item))
    tr.onclick = (event) => this.editItem(event, item)
    this.addElement(tr, 'td', item.name)
    this.addElement(tr, 'td', item.offset)
    this.addElement(tr, 'td', item.tag)
    this.addElement(tr, 'td', item.timezone)
    let btn = this.addDeleteButtonIcon(tr, 'td', this.canEdit())
    btn.onclick = (event) => this.askDeleteItem(event, item)
  }

  // addNewItemTDValues() {
  //   let elem = document.getElementById("newtable")
  //   if (!elem)
  //     return
  //   let tr = this.addElement(elem, "tr", '')
  //   if (!tr)
  //     return
  //   let el = this.addElement(tr, 'td', '')
  //   let fld = document.createElement('input')
  //   el.appendChild(fld)
  //   el = this.addElement(tr, 'td', '')
  //   fld = document.createElement('input')
  //   el.appendChild(fld)
  // }

  getItems() {
    document.body.style.cursor='wait';
    this.dataService.getCountries()
        .subscribe(items => this.afterGetItems(items))
  }


  deleteItem(item) {
    document.body.style.cursor='wait';
    this.dataService.deleteCountry(this.getItemId(item))
      .subscribe(res => this.afterSuccessfulDelete(res),
                 response => this.afterFailedDelete(response))
  }

  getValidators() {
    let vals = {}
    vals["countryCode"] = [Validators.required, StringValidator.cannotContainSpace]
    vals["name"] = [Validators.required]
    return vals
  }

  getDisabledFields() {
    let list = []
    return list
  }

  getNewItem() {
    return Country.getNewItem()
  }

  createItem(form) {

    let item = new Country()
    this.updateValues(item, form)
    let cat = item.toJson()
    this.dataService.updateCountry(cat)
    .subscribe(
      val => this.dataSuccess(val, 'PUT'),
      err => this.dataError(err, 'PUT'),
      () => {}
    )
  }

  // CAN WE LEAVE THIS IN BASE CLASS ONLY?
  updateValues(cat: Country, form: any) {
    let keys = this.getFormKeys(form)
    for (const key of keys) {
      if (form.get(key) instanceof UntypedFormControl) {
         cat[key] = form.get(key).value
      }
    }
  }

  haveDeleteAllFeature() {
    return false
  }

// END: OVERRIDDEN METHODS


}
